export default "__VITE_ASSET__Cg5kEFO___"